import React from 'react';
import './AgreementModal.css';
import { triggerHaptic } from '../services/telegram';

function AgreementModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="agreement-overlay" onClick={() => { triggerHaptic(); onClose?.(); }}>
      <div className="agreement-modal" onClick={(e) => e.stopPropagation()}>
        <div className="agreement-header">
          <h2 className="agreement-title">Пользовательское соглашение</h2>
          <button type="button" className="agreement-close" onClick={() => { triggerHaptic(); onClose?.(); }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="agreement-body">
          <section className="agreement-section">
            <h3 className="agreement-heading">Условия использования</h3>
            <p className="agreement-text">
              Используя Rocket, вы автоматически соглашаетесь с этими условиями использования и обязуетесь не нарушать законодательство Российской Федерации или других государств.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Сервис</h3>
            <p className="agreement-text">
              VPN-сервис обеспечивает конфиденциальность личной информации путём шифрования и анонимизации метаданных пользователя, скрывая его IP-адрес. Эти адреса используют множество других пользователей, что не только обеспечивает конфиденциальность для каждого из них, но и затрудняет определение характера их деятельности. Мы не изменяем, не перенаправляем и не внедряемся в пользовательский трафик.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Сервис</h3>
            <p className="agreement-text">
              Всем пользователям доступен демо период в течение трёх дней с момента авторизации в приложении.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Автоматическое продление</h3>
            <p className="agreement-text">
              Оплачивая подписку, вы соглашаетесь на автоматическое продление. Уведомление о том, что подписка закончится, приходит за один день до окончания подписки. Автоматическое продление можно отключить в любой момент в разделе «Профиль» → «Оплата».
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Использование подписки</h3>
            <p className="agreement-text">
              Подписка предоставляет право использования сервиса на неограниченном количестве устройств. Злоупотребление условиями использования сервиса может повлечь временное ограничение доступа или блокировку учётной записи без компенсации неиспользованного периода подписки.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Изменение стоимости подписки</h3>
            <p className="agreement-text">
              Мы оставляем за собой право изменять стоимость подписки. В случае повышения стоимости более чем на 10%, вы будете уведомлены заранее. Изменения вступают в силу со следующего платёжного периода.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Политика возврата</h3>
            <p className="agreement-text">
              Условия возврата: вы можете запросить возврат средств, если полученные услуги были некачественными или не предоставлены в соответствии с условиями. Процедура возврата: для запроса возврата свяжитесь с нашей службой поддержки по указанным контактным данным. Мы рассмотрим ваш запрос и произведём возврат средств. Сроки возврата: мы рассмотрим ваш запрос в течение дня. Срок исполнения возврата зависит от вашего банка.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Конфиденциальность</h3>
            <p className="agreement-text">
              Мы полностью сохраняем вашу анонимность при использовании нашего сервиса. Поэтому мы не собираем и не храним данные о вашей онлайн-активности и не передаём их третьим сторонам. Мы применяем передовые методы шифрования для защиты вашей информации.
            </p>
          </section>

          <section className="agreement-section">
            <h3 className="agreement-heading">Отказ от ответственности</h3>
            <p className="agreement-text">
              Мы оставляем за собой право изменять сервис, обновляя наше программное обеспечение или внося изменения в определённые функции. Мы стремимся минимизировать сбои и ошибки. Несмотря на наши усилия, сервис предоставляется на условиях «как есть» и «по мере доступности». Вы несёте единоличную ответственность за использование вами сервиса.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AgreementModal;
